"use client";

import { createContext, useContext } from "react";
const AutumnContext = createContext({
  encryptedCustomerId: "",
  customerData: {},
  authProvider: "better-auth",
  customer: null,
  setCustomer: () => {
  },
  paywallOpen: false,
  setPaywallOpen: () => {
  }
});
const useAutumnContext = () => {
  const context = useContext(AutumnContext);
  if (context === void 0) {
    throw new Error(
      "useAutumnContext must be used within a AutumnContextProvider"
    );
  }
  return context;
};
export {
  AutumnContext,
  useAutumnContext
};
